import React from 'react'
import { useTheme } from 'components/common/ThemeContext';

const AnalyticCard = ({index, title , value}) => {
    const { theme } = useTheme();
    const backgroundColor = index % 2 === 0 ? '#BD93FB' : '#E1CCFF';

  return (
    <div className='w-full h-[117px] px-5 py-5 rounded-[10px]' style={{border: '1px solid #000',  backgroundColor: backgroundColor}}>
        <p className='font-Inter text-[#0D0D0B] text-[16px] font-[500px]'>{title}</p>
        <p className='font-Inter text-[#000] text-[18px] font-[700px] mt-3'>{value}</p>
    </div>
  )
}

export default AnalyticCard
